import { useEffect } from "react";
import { useDispatch } from "react-redux";
import SubBanner from "../../comm/SubBanner";
import SubMenu from "../../comm/SubMenu";

function Greetings(props) {
  const dispatch = useDispatch();

  useEffect(
    () => {
      dispatch({
        type: "pageChange",
        payload: { sub01: "조합소개", sub02: "이사장 인사말" },
      });
      dispatch({ type: "loadingChange", payload: true });

      setTimeout(() => {
        dispatch({ type: "loadingChange", payload: false });
      }, 500);
    },
    // eslint-disable-next-line
    []
  );

  return (
    <>
      <SubBanner id="intro" />

      <section className="intro section">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <div className="row">
                <div className="col-12">
                  <h2>이사장 인사말</h2>
                  <span>홈페이지에 방문을 환영합니다.</span>
                </div>
              </div>

              <div className="row pt-30">
                <div className="col-lg-3 col-md-3 col-sm-12 text-center">
                  <img
                    src="./images/img-greetings.png"
                    alt="이사장 사진"
                    className="img-greeting"
                  />

                  <p
                    className="m-0 pt-20"
                    style={{ fontSize: ".9rem", lineHeight: "110%" }}
                  >
                    강원특별자치도
                    <br />
                    자동차검사정비사업조합
                  </p>
                  <h4 className="pt-10 pb-20">이사장 이상무</h4>
                </div>

                <div className="col-lg-9 col-md-9 col-sm-12">
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <h2>친환경차 시대, 끊임없는 믿음의 정비</h2>
                      </div>
                    </div>
                    <div className="row">
                      <div className="border-point-bar"></div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <p className="m-0">
                          강원특별자치도자동차검사정비사업조합 홈페이지를 방문해
                          주셔서 감사합니다.
                        </p>
                        <p className="m-0">
                          강원특별자치도자동차검사정비사업조합 제14대 이사장
                          이상무입니다.
                        </p>
                      </div>
                    </div>
                    <div className="row round-box mt-20">
                      <div className="col-12 pl-20 intro-greetings-contents">
                        <p>
                          저희 강원특별자치도자동차검사정비사업조합 임직원
                          일동은 급속도로 변화하는 친환경 자동차 시대에 맞추어
                          교육훈련 등을 통해 차질없이 준비해 가고 있으며, 국민의
                          생명과 재산을 보호하는 믿음과 신뢰의 정비를 실현하고자
                          불철주야 노력하고 있습니다.
                        </p>
                        <p>
                          새롭게 단장된 홈페이지를 통하여 조합원간에 원할한
                          정보교류 등 소통의 장이 되기를 희망해 봅니다.
                        </p>
                        <p>
                          앞으로도 조합의 노력에 지대한 관심과 협조를 부탁드리며
                          방문해 주신 모든 분들의 무궁한 발전과 행복이
                          가득하시기를 기원합니다.
                        </p>
                      </div>
                    </div>
                    <div className="row pt-30">
                      <div className="col-12 intro-greetings-contents text-right">
                        <h5>제14대 이사장 이상무 배상</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <SubMenu id="intro" />
          </div>
        </div>
      </section>
    </>
  );
}

export default Greetings;
